import { useEffect, useState } from 'react';

const NameSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const firstName = 'Enzo';
  const lastName = 'Chevallier';

  return (
    <section className="pt-4 mb-12">
      {/* Decorative line */}
      <div
        className={`w-12 h-px bg-gradient-to-r from-primary to-transparent mb-8 transition-all duration-1000 ease-out-expo ${
          isVisible ? 'opacity-100 w-12' : 'opacity-0 w-0'
        }`}
      />

      {/* Name with letter-by-letter reveal */}
      <h1 className="font-display leading-[0.9] tracking-tight perspective">
        {/* First name */}
        <span className="block overflow-hidden">
          <span
            className={`flex transition-transform duration-1000 ease-out-expo ${
              isVisible ? 'translate-y-0' : 'translate-y-full'
            }`}
            style={{ transitionDelay: '100ms' }}
          >
            {firstName.split('').map((letter, index) => (
              <span
                key={index}
                className="inline-block text-foreground hover:text-primary transition-colors duration-300"
                style={{
                  fontSize: 'clamp(3rem, 12vw, 7rem)',
                  transitionDelay: `${index * 30}ms`,
                }}
              >
                {letter}
              </span>
            ))}
          </span>
        </span>

        {/* Last name */}
        <span className="block overflow-hidden">
          <span
            className={`flex transition-transform duration-1000 ease-out-expo ${
              isVisible ? 'translate-y-0' : 'translate-y-full'
            }`}
            style={{ transitionDelay: '300ms' }}
          >
            {lastName.split('').map((letter, index) => (
              <span
                key={index}
                className="inline-block text-foreground hover:text-primary transition-colors duration-300"
                style={{
                  fontSize: 'clamp(3rem, 12vw, 7rem)',
                  transitionDelay: `${index * 30}ms`,
                }}
              >
                {letter}
              </span>
            ))}
          </span>
        </span>
      </h1>

      {/* Subtitle */}
      <div
        className={`mt-6 overflow-hidden transition-all duration-700 ease-out-expo ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
        style={{ transitionDelay: '800ms' }}
      >
        <p className="text-xs uppercase tracking-[0.3em] text-muted font-heading">
          <span className="inline-block mr-4">Developer</span>
          <span className="inline-block text-primary">&mdash;</span>
          <span className="inline-block ml-4">Project Manager</span>
        </p>
      </div>
    </section>
  );
};

export default NameSection;
